import { Fragment, useContext, useState } from "react";
import Avatar from "react-avatar";
import { AccountIcon } from "../components/icons/account-icon";
import routes from "../config/routes";
import Button from "../components/ui/button";
import Hamburger from "../components/ui/hamburger";
import ThemeSwitcher from "../components/ui/theme-switcher";
import ThemeContext from "../lib/theme/theme-context";
import { useNavigate } from "react-router-dom";
import { NavBalanceIcon } from "src/components/icons/balance-nav-icon";
import { useLocation } from "react-router-dom";
import useAuth from "../hooks/use-auth";
import { LogoutIcon } from "src/components/icons/logout-icon";
import { TwoFactorAuthIcon } from "src/components/icons/2fa-icon";
import { LockIcon } from "src/components/icons/lock-icon";
import { useLogout } from "../hooks/user";
import logo from "../assets/images/logo_text.png";

function AuthorizedMenu({ email }: { email: string }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { unauthorize } = useAuth();
  const { mutate: logout } = useLogout();
  const [dropDownOpen, setDropdownOpen] = useState(false);

  const onLogout = () => {
    //unauthorize();
    logout();
    // setTimeout(() => {
    //   // navigate(routes.home);
    // }, 200);
  };

  return (
    <div className="flex gap-[8px] sm:gap-[20px]">
      <Button
        variant="icon"
        className="gap-2 flex items-center justify-start group pr-[40px]"
        onClick={() => setDropdownOpen(!dropDownOpen)}
      >
        <p className="text-primary group-hover:text-error font-manrope text-[14px] font-medium leading-[16px] hidden sm:block">
          {email}
        </p>
        <span className="absolute top-[50%] transform translate-y-[-50%] right-2">
          {dropDownIcon}
        </span>
        {dropDownOpen && (
          <div className="absolute right-0 top-[100%] transform translate-y-[10%] w-full min-w-[160px] max-w-[180px] mt-1 z-[99] bg-white border border-[#ddd] rounded-xl shadow text-[#232800] text-xs font-medium max-h-[250px] overflow-y-auto">
            <div
              className="px-4 py-2 hover:bg-[#f5f5f5] cursor-pointer flex items-center justify-start gap-2.5"
              onClick={() => {
                setDropdownOpen(false);
                navigate(routes.profile);
              }}
            >
              <span className="icn">{profileIcn}</span> Profile
            </div>
            <div
              className="px-4 py-2 hover:bg-[#f5f5f5] cursor-pointer flex items-center justify-start gap-2.5"
              onClick={() => {
                setDropdownOpen(false);
                navigate(routes.profileTwoFA);
              }}
            >
              <TwoFactorAuthIcon className="w-[18px] h-[18px] text-primary" /> 2FA Manage
            </div>
            <div
              className="px-4 py-2 hover:bg-[#f5f5f5] cursor-pointer flex items-center justify-start gap-2.5"
              onClick={() => {
                setDropdownOpen(false);
                navigate(routes.profileChangePassword);
              }}
            >
              <LockIcon className="w-[18px] h-[18px] text-primary" /> Change Password
            </div>
            <div
              className="px-4 py-2 hover:bg-[#f5f5f5] cursor-pointer flex items-center justify-start gap-2.5"
              onClick={() => {
                setDropdownOpen(false);
                onLogout();
              }}
            >
              <LogoutIcon className="w-[20px] h-[20px] text-primary group-hover:text-error" />
              Logout
            </div>
          </div>
        )}
      </Button>
    </div>
  );
}

interface HeaderProps {
  isCollapse?: boolean;
  showHamburger?: boolean;
  onClickHamburger?: () => void;
}

export default function Header({
  isCollapse,
  showHamburger = false,
  onClickHamburger,
}: HeaderProps) {
  const { currentTheme, changeCurrentTheme } = useContext(ThemeContext);
  const isDarkMode = currentTheme === "dark";
  const navigate = useNavigate();
  const { isAuthorized, getCurrrentUser } = useAuth();

  return (
    <header className="app-header sticky top-0 z-30 flex h-16 w-full items-center justify-between border-b border-light-300 bg-light py-1 px-4 ltr:left-0 rtl:right-0 dark:border-dark-300 dark:bg-dark-250 sm:h-[70px] sm:px-6 static z-[9999]">
      <div className="flex items-center gap-2 flex-shrink-0 cursor-pointer z-[99999]">
        <a
          onClick={() => {
            navigate(routes.home);
          }}
        >
          <img
            src={
              // isDarkMode ? "/assets/nav_logo_dark.png" : "/assets/images/logo511.png"
              isDarkMode ? logo : logo
            }
            className="object-contain w-[113px] h-[32.78px]"
          />
        </a>
      </div>
      <div className="relative flex items-center gap-[12px]">
        {/* <ThemeSwitcher /> */}
        {isAuthorized ? (
          <AuthorizedMenu email={getCurrrentUser().email} />
        ) : (
          <></>
        )}
        {showHamburger && (
          <Hamburger
            isToggle={isCollapse}
            onClick={onClickHamburger}
            className="flex sm:hidden"
          />
        )}
      </div>
    </header>
  );
}

const dropDownIcon = (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const profileIcn = (
  <svg
    height={18}
    width={18}
    viewBox="0 0 22 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3333 5.16414C12.3333 7.37203 10.5426 9.16153 8.33329 9.16153C6.12396 9.16153 4.33329 7.37203 4.33329 5.16414C4.33329 2.95625 6.12396 1.16675 8.33329 1.16675C10.5426 1.16675 12.3333 2.95625 12.3333 5.16414Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    ></path>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 19.8213H1.66663C1.66663 18.8745 1.66663 17.9739 1.66663 17.1583C1.66663 14.9491 3.45749 13.1589 5.66663 13.1589H11C13.2091 13.1589 15 14.9491 15 17.1583C15 17.9739 15 18.8745 15 19.8213Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
    ></path>
  </svg>
);
